import { ComparisonMapping } from "../constants";

export function MapComparison(theValue) {
  return ComparisonMapping[theValue];
}
